import { render, staticRenderFns } from "./personalForm.vue?vue&type=template&id=32fda4ec&scoped=true&"
import script from "./personalForm.vue?vue&type=script&lang=js&"
export * from "./personalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fda4ec",
  null
  
)

export default component.exports